// @flow

import * as React from 'react';
import Box from 'sail/Box';
import {Link, DocsIcon} from 'docs/components';
import {useAccount} from 'docs/data';
import {normalizeHostname} from 'docs/util';
import {Card, CardBody, CardHeader} from './framework';
import type {CardBadgeDefinition} from './framework';

type BlockCardProps = {|
  badge?: CardBadgeDefinition,
  product?: string,
  children: React.Node,
  href: string,
  title: string,
|};

// TODO (nkohari): Rename to GuideCard? Didn't want to stomp on the existing implementation.
export const BlockCard = ({
  badge,
  children,
  href,
  title,
  product,
}: BlockCardProps) => {
  const {account} = useAccount();
  const productHeader = product ? (
    <Box margin={{bottom: 4}}>
      <DocsIcon size={20} category="product" icon={product} />
    </Box>
  ) : null;

  return (
    <Card bordered>
      {productHeader}
      <Link
        href={normalizeHostname(href, account.hosts)}
        title={title}
        className="no-api-tag"
      >
        <CardHeader text={title} badge={badge} />
        <CardBody>{children}</CardBody>
      </Link>
    </Card>
  );
};
